import { Component, Input, OnInit } from "@angular/core";
import { OrderService } from "src/app/services/order/order.service";

@Component({
  selector: "status-badge",
  templateUrl: "./status-badge.component.html",
  styleUrls: ["./status-badge.component.scss"]
})
export class StatusBadgeComponent implements OnInit {
  @Input()
  object: string;

  @Input()
  status: string;

  @Input()
  role: string;

  statusToColor = {
    draft: "tertiary",
    open: "secondary",
    accepted: "secondary",
    full: "primary",
    prepared: "tertiary",
    rejected:"light",
    distributing: "primary",
    delivered: "secondary",
    cancelled: "light",
    closed: "secondary",
    created: "tertiary",
    notAnswered: "primary"
  };

  constructor(public orderService:OrderService) {
  }

  ngOnInit() {}
}
